import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { CategoryCountResponseDto } from "@swagger/typescript-fetch-goflyer";
import { useTranslation } from "react-i18next";
import { messages } from "../../../locales/messages";
import { StatItem } from "./StatItem";
import { CategoryCard } from "./CategoryCard";

interface StatisticsContentProps {
  statistics: CategoryCountResponseDto;
}

export const StatisticsContent: React.FC<StatisticsContentProps> = ({
  statistics,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {/* Overview */}
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: 600, mb: 0.5, color: "#1a1a1a" }}
        >
          {t(messages.Overview())}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mb: 2, fontSize: "0.875rem" }}
        >
          {t(messages.Statistics_Summary_Description())}
        </Typography>
        <Grid container spacing={2}>
          <Grid
            item
            xs={6}
            sm={4}
            md={2.4}
            data-testid="statistics-total-flyer-items"
          >
            <StatItem
              title={t(messages.Total_Items())}
              value={statistics.totalItems || 0}
            />
          </Grid>
          <Grid
            item
            xs={6}
            sm={4}
            md={2.4}
            data-testid="statistics-front-page-items"
          >
            <StatItem
              title={t(messages.Front_Page())}
              value={statistics.frontPageCount || 0}
            />
          </Grid>
          <Grid
            item
            xs={6}
            sm={4}
            md={2.4}
            data-testid="statistics-goflyer-items"
          >
            <StatItem
              title={t(messages.Goflyer_website_APP())}
              value={statistics.goflyerCount || 0}
            />
          </Grid>
          <Grid
            item
            xs={6}
            sm={4}
            md={2.4}
            data-testid="statistics-supermarket-items"
          >
            <StatItem
              title={t(messages.Store_website_APP())}
              value={statistics.supermarketCount || 0}
            />
          </Grid>
          <Grid item xs={6} sm={4} md={2.4} data-testid="statistics-both-items">
            <StatItem
              title={t(messages.Both())}
              value={statistics.bothCount || 0}
            />
          </Grid>
        </Grid>
      </Box>

      {/* Categories Breakdown */}
      <Box>
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: 600, mb: 0.5, color: "#1a1a1a" }}
        >
          {t(messages.Categories_Breakdown())}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mb: 2, fontSize: "0.875rem" }}
        >
          {t(messages.Statistics_Categories_Description())}
        </Typography>
        <Grid container spacing={1.5}>
          {statistics.categoryCounts?.length > 0 ? (
            statistics.categoryCounts.map((category) => (
              <Grid item xs={12} sm={6} md={4} key={category.id}>
                <CategoryCard category={category} />
              </Grid>
            ))
          ) : (
            <Grid item xs={12}>
              <Typography
                variant="body1"
                sx={{ textAlign: "center" }}
                data-testid="statistics-no-category-data"
              >
                {t(messages.No_category_data_available())}
              </Typography>
            </Grid>
          )}
        </Grid>
      </Box>
    </>
  );
};
